export const getContactStateColor = (
  status?: LatestContactState
): SlugColorType => {
  if (!status) return 'gray';

  switch (status) {
    case 'active':
      return 'main';
    case 'READY_FOR_OUTREACH':
      return 'warning';
    case 'goal_reached':
      return 'success';
    case 'OUTREACH_FAILED':
      return 'danger';
    default:
      return 'danger';
  }
};
